/**
 * @Author: wangzhuang@baidu.com
 * @Date: 2023-01-10 17:48:54
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-08-22 23:52:17
 * @FilePath: /m-anquan-baidu-com/src/components/ProBanner/index.js
 * @Description: 通用产品页 banner
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './index.less';

export default class ProBanner extends Component {
    static propTypes = {
        title: PropTypes.string,
        bgImg: PropTypes.string,
        urlText: PropTypes.string,
        url: PropTypes.string,
        nextUrl: PropTypes.string,
        nextText: PropTypes.string,
    };

    render() {
        const {title, urlText, url, bgImg, nextUrl, nextText} = this.props;
        return (
            <div className={'proBanner'}>
                <div className={'banner-con pr'} style={{backgroundImage: `url(${bgImg})`}}>
                    <div className={'title'}>
                        {title}
                    </div>
                    <a href={url} onClick={e => {
                        if (this.isPageTitle('mesatee', title)) {
                            this.reportData('mesatee_banner');
                        }
                    }} className={'link'} target={'_blank'} >
                        {urlText}
                    </a>
                    {nextText ? (
                        <a href={nextUrl} target="_blank" className="compliance-btn">
                            {nextText}
                        </a>
                    ) : null}
                    <div className={'phone'}>
                        或致电：400-805-4999
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ProBanner/index.js